import { render, staticRenderFns } from "./TrashMailDetail.vue?vue&type=template&id=64dce626"
import script from "./TrashMailDetail.vue?vue&type=script&lang=js"
export * from "./TrashMailDetail.vue?vue&type=script&lang=js"
import style0 from "./TrashMailDetail.vue?vue&type=style&index=0&id=64dce626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports